import React from 'react';
import { Helmet } from "react-helmet-async";
import './brain.css';
import BrainHeader from './brain-header/BrainHeader';
import BrainIntroText from './brain-introtext/BrainIntroText';
import BrainYoutube from './brain-youtube/BrainYoutube';
import BrainInfo from './brain-info/BrainInfo';
import BrainInbetween from './brain-inbetween/BrainInbetween';
import BrainWebbPortal from './brain-webbportal/BrainWebbPortal';
import BrainInfoGrid from './brain-info-grid/BrainInfoGrid';

const Brain = () => {
    return (
        <>
            <Helmet>
                <title>BRA-in datastyrning för avfallshantering | Cycle Solutions</title>
                <meta
                    name="description"
                    content="BRA-in datastyrning från Cycle Solutions ger uppkopplad utrustning med övervakning, statistik och larm. Optimera fyllnadsgrad, service och kostnader"
                />
                <link
                    rel="canonical"
                    href="https://cyclesolutions.se/produkter/brain"
                />
            </Helmet>

            <div className='brain'>
                <BrainHeader />
                <BrainIntroText />
                <BrainYoutube />
                <BrainInfo />
                <BrainInbetween />
                <BrainWebbPortal />
                <BrainInfoGrid />
            </div>
        </>
    );
};

export default Brain;
